// Language Bar Module
export function initializeLanguageBar() {
  const languageBar = document.getElementById('languageBar');
  const body = document.body;

  if (!languageBar) {
    return;
  }

  // Check if user has previously closed the language bar
  const languageBarClosed = localStorage.getItem('languageBarClosed');

  // Show language bar initially
  languageBar.classList.add('show');

  // Language bar scroll direction detection
  let lastScrollY = window.scrollY;
  let scrollTimeout;

  window.addEventListener('scroll', function () {
    const currentScrollY = window.scrollY;
    const navbar = document.querySelector('.premium-navbar');

    if (!navbar) return;

    // If scrolled down more than 100px from top
    if (currentScrollY > 100) {
      // Check scroll direction
      if (currentScrollY > lastScrollY) {
        // Scrolling down - hide language bar, navbar stays at top
        languageBar.style.display = 'none';
        document.body.classList.remove('language-bar-visible');
        navbar.style.top = '0px';
        navbar.classList.add('scrolled');
      } else {
        // Scrolling up - show language bar, navbar below it
        languageBar.style.display = 'block';
        document.body.classList.add('language-bar-visible');
        // Set navbar position based on screen size
        if (window.innerWidth > 768) {
          navbar.style.top = '55px';
        } else {
          navbar.style.top = '40px';
        }
        navbar.classList.add('scrolled');
      }
    } else {
      // At top of page - always show language bar, navbar below it
      languageBar.style.display = 'block';
      document.body.classList.add('language-bar-visible');
      navbar.style.top = '43px';
      navbar.classList.remove('scrolled');
    }

    lastScrollY = currentScrollY;
  });

  // Track language selection
  document.querySelectorAll('.dropdown-item').forEach(link => {
    link.addEventListener('click', function (e) {
      const lang = this.getAttribute('data-lang');

      // Google Analytics tracking
      if (typeof gtag !== 'undefined') {
        gtag('event', 'language_change', {
          event_category: 'engagement',
          event_label: lang,
          custom_parameter: 'language_selection',
        });
      }

      // Facebook Pixel tracking
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'LanguageChange', {
          language: lang,
          content_category: 'User Interaction',
        });
      }

      // Close language bar after selection
      localStorage.setItem('languageBarClosed', 'true');
    });
  });
}
